import { PropsWithChildren, ReactNode, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useZoomFactor } from '~/hooks/useZoomFactor';
import { StyledAnchor, StyledTooltip } from './Tooltip.styled';

interface ITooltipProps {
	content: ReactNode;
}

const getTooltipPosition = (
	rect: Pick<DOMRect, 'left' | 'top' | 'width'>,
	zoomFactor: number,
) => ({
	left: (rect.left + rect.width / 2) / zoomFactor,
	top: rect.top / zoomFactor - 8,
});

const Tooltip = ({ children, content }: PropsWithChildren<ITooltipProps>) => {
	const anchorRef = useRef<HTMLSpanElement>(null);
	const zoomFactor = useZoomFactor();
	const [position, setPosition] = useState<{
		left: number;
		top: number;
	} | null>(null);

	const show = () => {
		const rect = anchorRef.current?.getBoundingClientRect();
		if (rect) {
			setPosition(getTooltipPosition(rect, zoomFactor));
		}
	};

	return (
		<StyledAnchor
			ref={anchorRef}
			onMouseEnter={show}
			onMouseLeave={() => setPosition(null)}
		>
			{children}
			{position &&
				createPortal(
					<StyledTooltip style={position}>{content}</StyledTooltip>,
					document.body,
				)}
		</StyledAnchor>
	);
};

export { getTooltipPosition, Tooltip };
